import { Link, useParams } from "react-router-dom";
import { sliderDataWeb } from "../constants/sliderData";
import { Github, Globe } from "lucide-react";
import "../styles/projectDetails.css";

const ProjectsDetails = () => {
	const params = useParams();
	const data = sliderDataWeb.filter((item) => item.id === params.id);

	return (
		<div className="component_wrapper">
			<div className="project_details_container">
				<div className="project_img_container">
					<img
						src={data[0].backgroundImage}
						alt={data[0].imgAlt}
						width={768}
					/>
				</div>
				<div className="project_details_content">
					<h2 className="project_title">{data[0].title}</h2>
					<p>{data[0].description}</p>
					<p>
						This website is responsive for different screen sizes with
						accessibility for better SEO support.
					</p>

					<div className="project_links">
						<Link
							to={data[0].github}
							target="_blank"
						>
							<Github size={18} />
							&nbsp;Github
						</Link>
						<Link
							to={data[0].link}
							target="_blank"
						>
							<Globe size={18} />
							&nbsp;View live
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProjectsDetails;
